import React from 'react';
import { ILogger } from './types';
import ConsoleLogger from './ConsoleLogger';

const LoggerContext = React.createContext<ILogger>(new ConsoleLogger());

export default LoggerContext;
